import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { useNavigate, useLocation } from 'react-router'
import { getBasePath } from '../../../../../../../utils/globals/link'

interface ModalDeleteConfigShippingZoneGroupProps extends ModalEditComponentProps { }

const ModalDeleteConfigShippingZoneGroup: React.FC<ModalDeleteConfigShippingZoneGroupProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleOnSubmit} = useModalDeleteConfigShippingZoneGroupLogic({onSubmit})
    const { handleFetchText } = useFetchText({
        onSubmit: handleOnSubmit, url: '/api/app/config/shipping/shippingZone/deleteShippingZoneGroup',
        data: {
            id: allRowData?.id
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteZone', '¿Seguro quieres eliminar esta zona?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

interface ModalDeleteConfigShippingZoneGroupLogicProps {
    onSubmit: OnSubmit
}

const useModalDeleteConfigShippingZoneGroupLogic = ({ onSubmit }: ModalDeleteConfigShippingZoneGroupLogicProps) =>
{
    const navigate = useNavigate();
    const location = useLocation().pathname

    const handleOnSubmit: OnSubmit = useCallback((res, value) => {
        onSubmit(res, value)
        navigate(getBasePath(location, 'shippingZones') + '/main')
    }, [onSubmit, navigate, location])
    return { handleOnSubmit }
}


export default ModalDeleteConfigShippingZoneGroup